@if (clientLogoAsset2()) {
  <div class="sidenav-header">
    <img
      [width]="profilePicSize()"
      [height]="profilePicSize()"
      [src]="'../assets/' + clientLogoAsset2()"
      alt="client logo"
    />
    @if (!collapsed()) {
      <div class="header-text">
        <h2>{{ heading() }}</h2>
        <p>{{ subTitle() }}</p>
      </div>
    }
  </div>
} @else {
  <div class="sidenav-no-logo"></div>
}
<div class="nav-wrapper">
  @if (collapsed()) {
    <div class="menu-rail" role="navigation" aria-label="Main navigation">
      @for (item of menuData(); track item.label) {
        @if (item.route) {
          <a
            class="rail-icon"
            [routerLink]="isViewingOther() ? null : item.route"
            routerLinkActive="rail-icon-active"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [class.menu-item-disabled]="isViewingOther()"
            [attr.aria-disabled]="isViewingOther()"
            [attr.aria-label]="item.label"
            [matTooltip]="item.label"
            matTooltipPosition="right"
            (click)="!isViewingOther() && closeFlyout()"
            #rla="routerLinkActive"
          >
            <mat-icon [svgIcon]="'sqep:' + item.icon" />
          </a>
        } @else {
          <button
            type="button"
            class="rail-icon"
            [class.rail-icon-active]="openItem() === item"
            [class.rail-icon-current]="hasActiveDescendant(item)"
            [class.menu-item-disabled]="isViewingOther()"
            [attr.aria-disabled]="isViewingOther()"
            [attr.aria-label]="item.label"
            [attr.aria-expanded]="openItem() === item"
            aria-haspopup="dialog"
            [attr.aria-controls]="openItem() === item ? 'menu-flyout-panel' : null"
            [matTooltip]="item.label"
            matTooltipPosition="right"
            (click)="!isViewingOther() && toggleFlyout(item, $event.currentTarget)"
          >
            <mat-icon [svgIcon]="'sqep:' + item.icon" />
          </button>
        }
      }
    </div>
  } @else {
    <mat-nav-list aria-label="Main navigation">
      @for (item of menuData(); track item.label) {
        <sqep-menu-item
          [item]="item"
          [isViewingOther]="isViewingOther()"
          [expanded]="openTopItem() === item"
          [counts]="menuCounts()"
          (toggled)="toggleTopItem(item)"
          (navigated)="changeCollapsedState.emit(true)"
        ></sqep-menu-item>
      }
    </mat-nav-list>
  }
  @if (isViewingOther() && !collapsed()) {
    <div class="viewing-overlay">
      <sqep-message status="Warning" [column]="true">
        <p>Menu is disabled while viewing as {{ viewingPersonName() }}.</p>
        <p>Close to return to your own data and continue working.</p>
        <sqep-button
          buttonCaption="Close"
          buttonTheme="sqep-button-primary small outline primary"
          (buttonClick)="clearViewingAs.emit()"
        ></sqep-button>
      </sqep-message>
    </div>
  }
</div>

<ng-template #flyoutContent>
  @if (openItem(); as item) {
    <div
      class="menu-flyout"
      id="menu-flyout-panel"
      [style.maxHeight.px]="flyoutMaxHeight()"
      role="dialog"
      aria-modal="true"
      aria-labelledby="menu-flyout-header"
      cdkTrapFocus
      cdkTrapFocusAutoCapture="true"
    >
      <div class="menu-flyout-header" id="menu-flyout-header">{{ item.label }}</div>
      @for (child of item.subMenu; track child.routeIdentifier ?? child.label; let last = $last) {
        <sqep-menu-item
          [item]="child"
          [depth]="1"
          [isLastChild]="last"
          [isViewingOther]="isViewingOther()"
          [expanded]="openFlyoutChild() === child"
          [inFlyout]="true"
          [counts]="menuCounts()"
          (toggled)="toggleFlyoutChild(child)"
          (navigated)="onFlyoutNavigated()"
        ></sqep-menu-item>
      }
    </div>
  }
</ng-template>
